import React from 'react'

import { useWIDGET_CONFIGS } from './_configs'
import BigCardPicker from '../../../packages/kiti/components/form/BigCardPicker'

const WidgetPicker = props => {
  const WIDGET_CONFIGS = useWIDGET_CONFIGS()
  return <BigCardPicker {...props} options={WIDGET_CONFIGS} />
}

export default WidgetPicker
